import { createStore } from "redux";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import { mobileReducer, cartReducer } from "./reducer";

// Define which reducers you want to persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cart"], // persist only the cart
};

const rootReducer = combineReducers({
  mobile: mobileReducer,
  cart: cartReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store with the persisted reducer
const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const persistor = persistStore(store);
export default store;
